module.exports = __webpack_public_path__ + "static/media/hot_zgzx.bcdc1cd8.png";